module.exports = __webpack_public_path__ + "static/img/tabbt2025_1.347594b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt2025_1.png
// module id = lpQ/
// module chunks = 1